module.exports = __webpack_public_path__ + "assets/img/activity-time-64901075.png";